import type { TextareaHTMLAttributes } from "react"
import { cn } from "@/lib/cn"

// Multi-line text input. Mirrors Input's styling so forms feel consistent.
type Props = TextareaHTMLAttributes<HTMLTextAreaElement>

export function Textarea({ className, ...rest }: Props) {
  return (
    <textarea
      {...rest}
      className={cn(
        "w-full resize-none rounded-control border border-border bg-white/5 px-3 py-2 text-sm text-app-text",
        "placeholder:text-app-subtle outline-none transition focus:border-brand-red/50",
        "disabled:opacity-50 disabled:pointer-events-none",
        className,
      )}
    />
  )
}
